jQuery(document).ready(function ($) {
  var module_name = "user_statistics";

  $(".clear-date-icon-from").click(function (e) {
    $("#card-input-date-from").val("");
  });

  $(".clear-date-icon-to").click(function (e) {
    $("#card-input-date-to").val("");
  });

  // Initialize DataTable on ALL player statistics tables (not just the first one)
  $(".player-statistics-table").each(function() {
    var $table = $(this);
    $table.DataTable({
      searching: false,
      language: {
        paginate: {
          next:     '<i class="fa fa-arrow-right" aria-hidden="true"></i>',
          previous: '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
        },
        search:       "Søk:",
        emptyTable:   "Ingen data tilgjengelig",
        info:         "Viser _START_ til _END_ av _TOTAL_ deltakere",
        infoEmpty:    "Viser 0 av 0 brukere ",
        lengthMenu:   "Vis _MENU_ deltakere",
        infoFiltered: "(filtrert fra totalt _MAX_ brukere)",
        zeroRecords:  "Ingen brukere funnet",
      },
      initComplete: function(settings, json) {
        // Wrap only the table in a scrollable div, not the pagination
        if (!$table.parent().hasClass('table-scroll-container')) {
          $table.wrap('<div class="table-scroll-container" style="overflow-x: auto; overflow-y: visible; -webkit-overflow-scrolling: touch;"></div>');
        }
      },
      drawCallback: function(settings) {
        var api = this.api();
        var $wrapper = $table.closest('.dataTables_wrapper');
        if (api.page.info().pages <= 1) {
          $wrapper.find('.dataTables_paginate').hide();
        } else {
          $wrapper.find('.dataTables_paginate').show();
        }
      }
    });
  });
  $('.dataTables_length').hide();

  $(".winning-percentage")
    .closest("tr.odd")
    .children("td:eq(0)")
  $(".winning-percentage")
    .closest("tr.odd")
    .children("td:eq(2)")
  $(".winning-percentage")
    .closest("tr.odd")
    .children("td:eq(3)")
  $(".winning-percentage")
    .closest("tr.odd")
    .children("td:eq(4)")
  $(".winning-percentage")
    .closest("tr.odd")
    .children("td:eq(5)")

  //  $(".winning-percentage").closest('tr').children('td:first').prepend($('<img>',{id:'theImg',src: document.location.origin + '/wp-content/themes/oddsnet.com/assets/images/winning-badge.png'}))
  //  $('.author-count:first').css('margin', '4px');

  $(".load-more").on("click", function () {
    const tipsElement = $(this).parent().siblings(".tips");
    const svgElement = $(this).siblings("svg");
    if ($(this).text() === "Show more") {
      tipsElement.removeClass("d-none");
      $(this).text("Show less");
      $(this).css({ "background-color": "#A4AFAB" });
      svgElement.css("transform", "rotate(180deg)");
    } else {
      tipsElement.addClass("d-none");
      $(this).text("Show more");
      $(this).css({ "background-color": "#EAF0EE" });
      svgElement.css("transform", "rotate(0deg)");
    }
  });

  $(document).load(function ($) {
    $("table").tablesorter();
  });

  getPagination("#table-id");
  $("#maxRows").trigger("change");
  function getPagination(table) {
    $("#maxRows").on("change", function () {
      $(".pagination").html(""); // reset pagination div
      var trnum = 0; // reset tr counter
      var maxRows = parseInt($(this).val()); // get Max Rows from select option

      var totalRows = $(table + " tbody tr").length; // numbers of rows
      $(table + " tr:gt(0)").each(function () {
        // each TR in  table and not the header
        trnum++; // Start Counter
        if (trnum > maxRows) {
          // if tr number gt maxRows

          $(this).hide(); // fade it out
        }
        if (trnum <= maxRows) {
          $(this).show();
        } // else fade in Important in case if it ..
      }); //  was fade out to fade it in
      if (totalRows > maxRows) {
        // if tr total rows gt max rows option
        var pagenum = Math.ceil(totalRows / maxRows); // ceil total(rows/maxrows) to get ..
        //	numbers of pages
        for (var i = 1; i <= pagenum; ) {
          // for each page append pagination li
          $(".pagination")
            .append(
              '<li data-page="' +
                i +
                '">\
								      <span>' +
                i++ +
                '<span class="sr-only">(current)</span></span>\
								    </li>'
            )
            .show();
        } // end for i
      } // end if row count > max rows
      $(".pagination li:first-child").addClass("active"); // add active class to the first li

      //SHOWING ROWS NUMBER OUT OF TOTAL DEFAULT
      showig_rows_count(maxRows, 1, totalRows);
      //SHOWING ROWS NUMBER OUT OF TOTAL DEFAULT

      $(".pagination li").on("click", function (e) {
        // on click each page
        e.preventDefault();
        var pageNum = $(this).attr("data-page"); // get it's number
        var trIndex = 0; // reset tr counter
        $(".pagination li").removeClass("active"); // remove active class from all li
        $(this).addClass("active"); // add active class to the clicked

        //SHOWING ROWS NUMBER OUT OF TOTAL
        showig_rows_count(maxRows, pageNum, totalRows);
        //SHOWING ROWS NUMBER OUT OF TOTAL

        $(table + " tr:gt(0)").each(function () {
          // each tr in table not the header
          trIndex++; // tr index counter
          // if tr index gt maxRows*pageNum or lt maxRows*pageNum-maxRows fade if out
          if (
            trIndex > maxRows * pageNum ||
            trIndex <= maxRows * pageNum - maxRows
          ) {
            $(this).hide();
          } else {
            $(this).show();
          } //else fade in
        }); // end of for each tr in table
      }); // end of on click pagination list
    });
  }

  // $(function () {
  //   // Just to append id number for each row
  //   default_index();
  //   FilterkeyWord_all_table();
  // });

  //ROWS SHOWING FUNCTION
  function showig_rows_count(maxRows, pageNum, totalRows) {
    //Default rows showing
    var end_index = maxRows * pageNum;
    var start_index = maxRows * pageNum - maxRows + parseFloat(1);
    var string =
      "Showing " +
      start_index +
      " to " +
      end_index +
      " of " +
      totalRows +
      " entries";
    $(".rows_count").html(string);
  }

  // All Table search script
  // function FilterkeyWord_all_table() {
  //   var count = $(".table")
  //     .children("tbody")
  //     .children("tr:first-child")
  //     .children("td").length;

  //   // Declare variables
  //   var input, filter, table, tr, td, i;
  //   input = document.getElementById("search_input_all");
  //   var input_value = document.getElementById("search_input_all").value;
  //   filter = input.value.toLowerCase();
  //   if (input_value != "") {
  //     table = document.getElementById("table-id");
  //     tr = table.getElementsByTagName("tr");

  //     // Loop through all table rows, and hide those who don't match the search query
  //     for (i = 1; i < tr.length; i++) {
  //       var flag = 0;

  //       for (j = 0; j < count; j++) {
  //         td = tr[i].getElementsByTagName("td")[j];
  //         if (td) {
  //           var td_text = td.innerHTML;
  //           if (td.innerHTML.toLowerCase().indexOf(filter) > -1) {
  //             //var td_text = td.innerHTML;
  //             //td.innerHTML = 'shaban';
  //             flag = 1;
  //           } else {
  //             //DO NOTHING
  //           }
  //         }
  //       }
  //       if (flag == 1) {
  //         tr[i].style.display = "";
  //       } else {
  //         tr[i].style.display = "none";
  //       }
  //     }
  //   }
  // }
});
